export default "__VITE_ASSET__JTGvKWUx__"